import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FileItem from './FileItem/FileItem-redux';
import styles from '../styles.module.scss';

export function UploadedFilesGrid({
                                    shumaID,
                                    stepID,
                                    files,
                                    closeModal,
                                    fileUploaded,
                                    handleSubmit,
                                    getFile,
                                    showShumaId = false,
                                    copyFile,
                                    fileTypeID,
                                    showHelka = true
                                  }) {
  const mapFiles = file => {
    const {
      fileID,
      uploadTime,
      fileName,
      ttHelkaID,
      fileExtension,
      shumaID: originShumaID
    } = file;

    return (
      <FileItem
        shumaId={shumaID}
        stepId={stepID}
        fileID={fileID}
        uploadTime={uploadTime}
        fileName={fileName}
        ttHelkaID={ttHelkaID}
        fileExtension={fileExtension}
        closeModal={closeModal}
        fileUploaded={fileUploaded}
        handleSubmit={handleSubmit}
        getFile={getFile}
        showShumaIdColumn={showShumaId}
        originShumaID={originShumaID}
        copyFile={copyFile}
        fileTypeID={fileTypeID}
        showHelkaColumn={showHelka}
      />
    );
  };

  return (
    <div className={styles.filesListHeaderContainer}>
      <div className={styles.headers}>
        <div className={classnames(styles.headersItem, styles.date)}>
          תאריך
        </div>
        {showShumaId && (
          <div className={classnames(styles.headersItem, styles.shumaID)}>
            מס' דוח
          </div>
        )}
        <div className={classnames(styles.headersItem, styles.fileName, {
          [styles.shorted]: showShumaId, [styles.increased]: !showHelka,
        })}>
          שם הקובץ
        </div>
        {showHelka && (
          <div className={classnames(styles.headersItem, styles.ttHelka)}>
            תת חלקה
          </div>
        )}
        <div className={classnames(styles.headersItem, styles.selectButton)}>
          בחירה
        </div>
      </div>
      <div className={styles.gridBody}>
        {files.map(mapFiles)}
      </div>
    </div>
  );

}

UploadedFilesGrid.propTypes = {
  getFile: PropTypes.func,
  showShumaId: PropTypes.bool,
  copyFile: PropTypes.func,
};
